import { useEffect, useState } from "react";
import { FaWordpress, FaTimes, FaTimesCircle, FaFileInvoiceDollar, FaChartLine, FaChartBar } from "react-icons/fa";
import SearchIcon from '@mui/icons-material/Search';
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import Button from '@mui/material/Button';
import DetailsButton from "../components/ui/components/DetailsButton";
import { toast } from "react-toastify";
import DrawerCotizacionCalendarioPagosDetails from "../components/calendarioPagos/DrawerCotizacionCalendarioPagosDetails";
import { useSelector } from "react-redux";
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';
import { FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Checkbox } from "@mui/material";
import { CheckCircle, CleanHands, ClearAll, Refresh } from "@mui/icons-material";
import { formatDate, months, years } from "../utils/rawData/dateValues";
import Selector from "../components/ui/components/Selector";

const VentasSupuestos = () => {

  const user = useSelector((state) => state.auth?.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() !== "ASISTENTE"
  
  const [loading, setLoading] = useState(false)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [dataDrawer, setDataDrawer] = useState(null)

  const [page, setPage] = useState(1);
  const [brandName, setBrandName] = useState("");

  const [view, setView] = useState("Tabla")

  const [record, setRecord] = useState([])
  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [sellers, setSellers] = useState([])
  const [paises, setPaises] = useState([])
  const [currencyExchanges, setCurrencyExchanges] = useState({})

  const [selectedSeller, setSelectedSeller] = useState("Todos")

  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1); // getMonth() devuelve 0-11, sumamos 1 para obtener 1-12

  const getRecord = async () => {
    try {
      setLoading(true)
      let url = `${BACKEND}/api/getCotizacionesData?userId=${user.id}&year=${year}&month=${month}`
      if (selectedSeller !== "Todos") {
        url += `&seller=${selectedSeller}`
      }
      if (brandName) {
        url += `&brandName=${brandName}`
      }
      const response = await axios.get(url)
      setRecord(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
    } catch (error) {
      toast.error("Error al obtener los datos")
    } finally {
      setLoading(false)
    }
  }

  const getSellers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0`);
      const sellers = response.data.docs.filter((v) => v.area.toUpperCase() === "COMERCIAL" || v.area.toUpperCase() === "ADMINISTRACION")
      setSellers(sellers)
    } catch (error) {
      toast.error("Error al obtener los vendedores")
    }
  };

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`);
      setPaises(response.data.docs);
    } catch (error) {
      console.error(error);
    }
  }

  const getCurrencyExchange = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`)
      const currencyExchanges = response.data.docs.reduce((acc, item) => {
        acc[item.moneda] = item.tipoCambio
        return acc
      }, {})
      setCurrencyExchanges(currencyExchanges)
    } catch (error) {
      return false
    }
  }

  const handleOpenDrawer = async (id) => {
    try {
      const response = await axios.get(`${BACKEND}/api/cotizaciones/${id}`)
      setDataDrawer(response.data)
      setOpenDrawer(true)
    } catch (error) {
      toast.error("Error al obtener la cotización")
    }
  } 
      
  const handleResetSearch = () => {
    setBrandName("");
  }

  const handleSearchClients = () => {
    setPage(1)
    getRecord()
  };

  useEffect(() => {
    getRecord()
  }, [year, month, selectedSeller])

  useEffect(() => {
    getRecord()
    getSellers()
    getPaises()
    getCurrencyExchange()
  }, [])

  const chartData = (() => {
    // Agrupar ventas por categoría de servicio
    const serviceCategories = {};
    
      record.forEach((c) => {
        // console.log(c.fechaVenta)
        // Calcular ventas reales del mes
        // const currentMonth = month;
        // const currentYear = year; 

        const saleDate = new Date(c.fechaVenta);
        const currentMonth = saleDate.getMonth();
        const currentYear = saleDate.getFullYear();
        
        // console.log(currentMonth + " / " + currentYear)
      
      const currentMonthPayments = c.pagos
        .filter((p) => {
          const paymentDate = new Date(p.fechaLimite);
          return paymentDate.getMonth() === currentMonth && paymentDate.getFullYear() === currentYear;
        });
      
      const firstPaymentMonth = currentMonthPayments.length > 0 ? currentMonthPayments[currentMonthPayments.length - 1].precio : 0;
      
      // Procesar cada servicio de la cotización
      c.servicios.forEach((s) => {
        const serviceName = s.servicio.name;
        
        if (!serviceCategories[serviceName]) {
          serviceCategories[serviceName] = {
            ventasReales: 0,
            proyeccionFuturos: 0,
            cantidadCotizaciones: 0
          };
        }
        
        // Distribuir proporcionalmente las ventas entre servicios
        const totalServices = c.servicios.length;
        const ventasRealesPorServicio = firstPaymentMonth / totalServices;
        const totalPayments = c.pagos.reduce((sum, p) => sum + p.precio, 0);
        const proyeccionFuturosPorServicio = (totalPayments - firstPaymentMonth) / totalServices;
        
        serviceCategories[serviceName].ventasReales += ventasRealesPorServicio;
        serviceCategories[serviceName].proyeccionFuturos += proyeccionFuturosPorServicio;
        serviceCategories[serviceName].cantidadCotizaciones += 1;
      });
    });
    
    // Convertir a formato para el gráfico
    return Object.entries(serviceCategories).map(([service, data]) => ({
      servicio: service,
      "Ventas Reales": Math.round(data.ventasReales * 100) / 100,
      "Proyección Futuros": Math.round(data.proyeccionFuturos * 100) / 100,
      "Cantidad Cotizaciones": data.cantidadCotizaciones
    }));
  })();

  const sellerChartData = (() => {
    // Agrupar ventas por vendedor (Opción 1: Vendedor con métricas separadas)
    const sellerData = {};
    
    record.forEach((c) => {
      const sellerName = c.cotizador.name;
      const saleDate = new Date(c.fechaVenta);
      const saleYear = saleDate.getFullYear();
      
      // Solo incluir datos del año seleccionado
      if (saleYear === year) {
        if (!sellerData[sellerName]) {
          sellerData[sellerName] = {
            ventasReales: 0,
            proyeccionFuturos: 0,
            cantidadCotizaciones: 0
          };
        }
        
        // Calcular ventas usando la fecha de venta de cada cotización
        const currentMonth = saleDate.getMonth();
        const currentYear = saleDate.getFullYear();
        
        const currentMonthPayments = c.pagos
          .filter((p) => {
            const paymentDate = new Date(p.fechaLimite);
            return paymentDate.getMonth() === currentMonth && paymentDate.getFullYear() === currentYear;
          });
        
        const firstPaymentMonth = currentMonthPayments.length > 0 ? currentMonthPayments[currentMonthPayments.length - 1].precio : 0;
        const totalPayments = c.pagos.reduce((sum, p) => sum + p.precio, 0);
        const proyectedPayments = totalPayments - firstPaymentMonth;
        
        sellerData[sellerName].ventasReales += firstPaymentMonth;
        sellerData[sellerName].proyeccionFuturos += proyectedPayments;
        sellerData[sellerName].cantidadCotizaciones += 1;
      }
    });
    
    // Convertir a formato para el gráfico - cada fila es un vendedor
    const chartData = [];
    
    Object.entries(sellerData).forEach(([seller, data]) => {
      const sellerRow = {
        vendedor: seller,
        "Ventas Reales": Math.round(data.ventasReales * 100) / 100,
        "Proyección Futuros": Math.round(data.proyeccionFuturos * 100) / 100,
        "Cantidad Cotizaciones": data.cantidadCotizaciones
      };
      
      chartData.push(sellerRow);
    });
    
    return chartData;
  })();

  // Crear keys para las métricas de vendedores
  const sellerKeys = ["Ventas Reales", "Proyección Futuros"];

  return (
    <div className="flex flex-col h-screen w-full">

      <DrawerCotizacionCalendarioPagosDetails
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        dataDrawer={dataDrawer}
        refetch={getRecord}
        isAdmin={isAdmin}
        paises={paises}
        currencyExchanges={currencyExchanges}
      />

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaChartBar className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Supuestos de ventas</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <Selector 
               title="Vista" 
               setter={setView} 
               value={view} 
               options={[{label: "Tabla", value: "Tabla"}, {label: "Gráfico", value: "Gráfico"}]}
             />

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
              {brandName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>
            
            <div>
              <Button 
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Filtros */}
      <div className="flex flex-row items-center justify-between w-full bg-gray-100 mb-0.5 mt-0.5 px-6 gap-2">
        <div className="flex flex-row items-center justify-center w-full">

          <div className="flex flex-row gap-4 items-center justify-center">
            <Selector 
              title="Vendedor" 
              setter={setSelectedSeller} 
              value={selectedSeller} 
              options={sellers.map((s) => {
                return {
                  value: s.id,
                  label: s.name
                }
              })} 
              defaultValue="Todos" 
              defaultText="Todos" 
            />

            <Selector 
               title="Mes" 
               setter={setMonth} 
               value={month} 
               options={[{label: "Todos", value: ""}, ...months]}
             />

            <Selector 
              title="Año" 
              setter={setYear} 
              value={year} 
              options={years} 
            />
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
          <LoadingScreen />
        ) : (
          record.length === 0 ? (
            <NoDataScreen />
          ) : (
            view === "Tabla" ? (
              <table className="w-full text-xs">
                <thead className="sticky top-0 bg-gray-200 z-50">
                  <tr className="text-gray-700 text-center text-xs font-bold z-50">
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Cotización
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 sticky left-0 text-white z-50">
                      Servicios
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Vendedor
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Mes
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Año
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Cliente
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Fecha creación
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Fecha venta
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Pais
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Ventas reales
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Ventas totales proyectadas
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Proyeccion de futuros pagos
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      N° de cuotas
                    </th>
                  </tr>
                  <tr className="bg-gray-100 font-bold text-xs text-center">
                    <td colSpan={9} className="py-2 border border-gray-300">
                      Totales
                    </td>
                    <td className="text-green-600 py-2 border border-gray-300">
                      S/. {(() => {
                        const totalVentasReales = record.reduce((sum, c) => {
                          const currentMonth = month - 1;
                          const currentYear = year;
                          
                          const currentMonthPayments = c.pagos
                            .filter((p) => {
                              const paymentDate = new Date(p.fechaLimite);
                              return paymentDate.getMonth() === currentMonth && paymentDate.getFullYear() === currentYear;
                            });
                          
                          // Solo el primer pago del mes (el último en la lista)
                          const firstPaymentMonth = currentMonthPayments.length > 0 ? currentMonthPayments[currentMonthPayments.length - 1].precio : 0;
                          return sum + firstPaymentMonth;
                        }, 0);
                        return totalVentasReales.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      })()}
                    </td>
                    <td className="text-blue-600 py-2 border border-gray-300">
                      S/. {(() => {
                        const totalVentasProyectadas = record.reduce((sum, c) => {
                          const totalPayments = c.pagos.reduce((sum, p) => sum + p.precio, 0);
                          return sum + totalPayments;
                        }, 0);
                        return totalVentasProyectadas.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      })()}
                    </td>
                    <td className="text-yellow-500 py-2 border border-gray-300">
                      S/. {(() => {
                        const totalProyeccionFuturos = record.reduce((sum, c) => {
                          const currentMonth = month - 1;
                          const currentYear = year;
                          
                          const currentMonthPayments = c.pagos
                            .filter((p) => {
                              const paymentDate = new Date(p.fechaLimite);
                              return paymentDate.getMonth() === currentMonth && paymentDate.getFullYear() === currentYear;
                            });
                          
                          const firstPaymentMonth = currentMonthPayments.length > 0 ? currentMonthPayments[currentMonthPayments.length - 1].precio : 0;
                          const totalPayments = c.pagos.reduce((sum, p) => sum + p.precio, 0);
                          const proyectedPayments = totalPayments - firstPaymentMonth;
                          
                          return sum + proyectedPayments;
                        }, 0);
                        return totalProyeccionFuturos.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      })()}
                    </td>
                    <td className="text-blue-600 py-2 border border-gray-300">
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {record.map((c) => {

                    const currentMonthPayments = (() => {
                      const currentDate = new Date();

                      // const currentMonth = month - 1
                      // const currentYear = year;

                      const sellDate = new Date(c.fechaVenta)
                      const currentMonth = sellDate.getMonth()
                      const currentYear = sellDate.getFullYear();

                      console.log(currentMonth + " / " + currentYear)
                      
                      return c.pagos
                        .filter((p) => {
                          const paymentDate = new Date(p.fechaLimite);
                          return paymentDate.getMonth() === currentMonth && paymentDate.getFullYear() === currentYear;
                        })
                        .reduce((sum, p) => sum + p.precio, 0)
                    })()

                    const firstPaymentMonth = (() => {
                      // const currentMonth = month - 1;
                      // const currentYear = year;

                      const sellDate = new Date(c.fechaVenta)
                      const currentMonth = sellDate.getMonth()
                      const currentYear = sellDate.getFullYear();
                      
                      const currentMonthPayments = c.pagos
                        .filter((p) => {
                          const paymentDate = new Date(p.fechaLimite);
                          return paymentDate.getMonth() === currentMonth && paymentDate.getFullYear() === currentYear;
                        });
                      
                      return currentMonthPayments.length > 0 ? currentMonthPayments[currentMonthPayments.length - 1].precio : null;
                    })()

                    const quoteId = c.id

                    const totalPayments = c.pagos.reduce((sum, p) => sum + p.precio, 0)

                    const proyectedPayments = totalPayments - firstPaymentMonth

                    // console.log("Primer pago: " + firstPaymentMonth)
                    // console.log("Pagos totales: " + totalPayments)
                    // console.log("Pagos proyectados " + proyectedPayments)
                    return (
                      <tr key={c.id} className="text-xs py-1 w-full hover:bg-gray-100 transition-all duration-100 z-10">
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <div className="flex flex-row items-center justify-center gap-2">
                            <DetailsButton
                              content={quoteId}
                              action={() => handleOpenDrawer(quoteId) }
                            />
                          </div>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-start border border-gray-300">
                          <ul className="list-disc pl-4">
                            {c.servicios.map((s) => (
                              <li key={s.id}> {s.servicio.name}</li>
                            ))}
                          </ul>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <span className="">{c.cotizador.name}</span>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <span className="">{(() => {
                            const date = new Date(c.fechaVenta);
                            date.setHours(date.getHours() + 5);
                            const monthIndex = date.getMonth(); // getMonth() returns 0-11
                            return months[monthIndex].label;
                          })()}</span>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <span className="">{(() => {
                            const date = new Date(c.fechaVenta);
                            const yearValue = date.getFullYear();
                            const yearObject = years.find(y => y.value === yearValue);
                            return yearObject ? yearObject.label : yearValue;
                        })()}</span>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <div className="flex flex-row gap-2 items-center justify-between w-[15rem] max-w-[15rem]">
                            <span className="truncate">{c.cliente.nombreComercial}</span>
                          </div>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <span className="truncate">{formatDate(c.createdAt.split("T")[0])}</span>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <span className="truncate">{formatDate(c.fechaVenta.split("T")[0])}</span>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <span className="truncate">{c.cliente.pais}</span>
                        </td>
                        <td className={`${!firstPaymentMonth ? "text-gray-200" : "text-black"} px-4 py-2 whitespace-nowrap text-center border border-gray-300}`}>
                          <span className="truncate">S/. {firstPaymentMonth > 0 ? firstPaymentMonth.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}</span>
                        </td>
                        <td className={`${!totalPayments ? "text-gray-200" : "text-black"} px-4 py-2 whitespace-nowrap text-center border border-gray-300`}>
                          <span className="truncate">S/. {totalPayments > 0 ? totalPayments.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}</span>
                        </td>
                        <td className={`${!proyectedPayments ? "text-gray-200" : "text-black"} px-4 py-2 whitespace-nowrap text-center border border-gray-300`}>
                          <span className="truncate">S/. {proyectedPayments > 0 ? proyectedPayments.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0} </span>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <span className="truncate">{c.pagos.length}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className="flex flex-col gap-4 w-full">  

                {/* Gráfico 1 */}                
                <div className="flex flex-col gap-4 w-full">
                  <h1 className="text-sm font-bold text-gray-800 text-start px-6 pt-6">
                    Ventas por Categoría de Servicio - {months[month-1]?.label || 'Todos los meses'} {year}
                  </h1>
                  <div className="w-full h-[600px] rounded-lg px-4">
                    {chartData.length > 0 ? (
                                              <ResponsiveBar
                          data={chartData}
                          keys={["Ventas Reales", "Proyección Futuros"]}
                        indexBy="servicio"
                        margin={{ top: 50, right: 150, bottom: 100, left: 100 }}
                        padding={0.08}
                        groupMode={month ? "grouped" : "stacked"}
                        valueScale={{ type: 'linear' }}
                        indexScale={{ type: 'band', round: true }}
                        colors={{ scheme: 'paired' }}
                        borderColor={{
                          from: 'color',
                          modifiers: [['darker', 1.6]]
                        }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: -20,
                          legend: 'Categoría de Servicio',
                          legendPosition: 'middle',
                          legendOffset: 80
                        }}
                        axisLeft={{
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          legend: 'Monto (S/.)',
                          legendPosition: 'middle',
                          legendOffset: -80,
                          format: (value) => `S/. ${value.toLocaleString('es-PE')}`
                        }}
                        labelSkipWidth={12}
                        labelSkipHeight={12}
                        legends={[
                          {
                            dataFrom: 'keys',
                            anchor: 'right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                              {
                                on: 'hover',
                                style: {
                                  itemOpacity: 1
                                }
                              }
                            ]
                          }
                        ]}
                        tooltip={({ id, value, color }) => (
                          <div
                            style={{
                              padding: 12,
                              color: 'white',
                              background: '#333',
                              borderRadius: '4px',
                              border: '1px solid #555'
                            }}
                          >
                            <strong>{id}:</strong> S/. {value.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </div>
                        )}
                        animate={true}
                        motionStiffness={90}
                        motionDamping={15}
                      />
                    ) : (
                      <div className="flex items-center justify-center h-full">
                        <p className="text-gray-500 text-lg">No hay datos para mostrar</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Gráfico 2 */}
                <div className="flex flex-col gap-4 w-full">
                  <h1 className="text-sm font-bold text-gray-800 text-start px-6 pt-6">
                    Ventas por Vendedor - {month ? months[month-1]?.label : "Todos los meses"} {year}
                  </h1>
                  <div className="w-full h-[600px] rounded-lg px-4">
                    {sellerChartData.length > 0 ? (
                      <ResponsiveBar
                        data={sellerChartData}
                        keys={sellerKeys}
                        indexBy="vendedor"
                        margin={{ top: 50, right: 150, bottom: 70, left: 100 }}
                        padding={0.08}
                        groupMode="grouped"
                        valueScale={{ type: 'linear' }}
                        indexScale={{ type: 'band', round: true }}
                        colors={{ scheme: 'paired' }}
                        borderColor={{
                          from: 'color',
                          modifiers: [['darker', 1.6]]
                        }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: -20,
                          legend: 'Vendedor',
                          legendPosition: 'middle',
                          legendOffset: 80
                        }}
                        axisLeft={{
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          legend: 'Monto (S/.)',
                          legendPosition: 'middle',
                          legendOffset: -80,
                          format: (value) => `S/. ${value.toLocaleString('es-PE')}`
                        }}
                        labelSkipWidth={12}
                        labelSkipHeight={12}
                        legends={[
                          {
                            dataFrom: 'keys',
                            anchor: 'right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 4,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                              {
                                on: 'hover',
                                style: {
                                  itemOpacity: 1
                                }
                              }
                            ]
                          }
                        ]}
                        tooltip={({ id, value, color }) => (
                          <div
                            style={{
                              padding: 12,
                              color: 'white',
                              background: '#333',
                              borderRadius: '4px',
                              border: '1px solid #555'
                            }}
                          >
                            <strong>{id}:</strong> S/. {value.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </div>
                        )}
                        animate={true}
                        motionStiffness={90}
                        motionDamping={15}
                      />
                    ) : (
                      <div className="flex items-center justify-center h-full">
                        <p className="text-gray-500 text-lg">No hay datos para mostrar</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>  
            )
          )
        )}
      </div>

    </div>
  );
};

export default VentasSupuestos;